import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import {
  FaFacebookF,
  FaInstagram,
  FaRegUser,
  FaTimes,
  FaWhatsapp,
  FaYoutube,
} from "react-icons/fa";

import { FaBars, FaCartShopping } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { BsFillGiftFill } from "react-icons/bs";
import { Offcanvas } from "react-bootstrap";
import SigninLeft from "./SignInLeft";
import axios from "axios";

function Header({ handleclick }) {
  const navigate = useNavigate();
  const [isSticky, setIsSticky] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const token = localStorage.getItem("token");
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const user_id = localStorage.getItem("user_id");
  const [fooder, setfooder] = useState("");

  useEffect(() => {
    if (handleclick) {
      handleShow();
    }
  }, [handleclick]);

  useEffect(() => {
    footerdata();
  }, []);

  useEffect(() => {
    const profilelist = async () => {
      const token = localStorage.getItem("token");
      const user_id = localStorage.getItem("user_id");
      if (!token || !user_id) return;
      try {
        const res = await fetch(`${process.env.REACT_APP_BASE_URL}/profile`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ id: user_id }),
        });

        if (!res.ok) throw new Error("Failed to fetch profile");
        const data = await res.json();
        if (!data.data || data.data.token !== token) {
          throw new Error("Invalid token");
        }
      } catch (err) {
        console.error("Profile error:", err.message);
        localStorage.removeItem("token");
        localStorage.removeItem("user_id");
        // localStorage.removeItem("package_id");

        // Redirect to home/login
        navigate("/");
      }
    };

    profilelist();
  }, [navigate]);

  const footerdata = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/site-setting`
      );
      setfooder(res.data.data);
    } catch (error) {}
  };

  const toggleDropdown = (menuName) => {
    setOpenDropdown((prev) => (prev === menuName ? null : menuName));
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 130) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const location = useLocation();
  const currentPath = location.pathname;
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (location.pathname === "/" && params.get("ref")) {
      setShow(true); // login/register Offcanvas open
    }
  }, [location]);

  const [cartCount, setCartCount] = useState(
    parseInt(localStorage.getItem("cartCount") || 0)
  );
  useEffect(() => {
    const handleStorageChange = () => {
      setCartCount(parseInt(localStorage.getItem("cartCount") || 0));
    };
    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("cartUpdated", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("cartUpdated", handleStorageChange);
    };
  }, []);

  return (
    <>
      <nav
        className={`main-menu ${
          isSticky ? "stricky-fixed stricky-header stricked-menu" : ""
        }`}
      >
        <div className="container">
          <div className={`main-menu__block ${isMenuOpen ? "open" : ""}`}>
            <div className={`main-menu__left ${isMenuOpen ? "open" : ""}`}>
              <div className="main-menu__logo">
                <Link to="/">
                  <img src={logo} alt="Educate" loading="lazy"/>
                </Link>
              </div>

              <div className={`main-menu__nav`}>
                <ul className="main-menu__list">
                  <li>
                    <NavLink
                      to="/"
                      className={({ isActive }) => (isActive ? "active" : "")}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      Home
                    </NavLink>
                  </li>

                  <li
                    className={`dropdown ${
                      openDropdown === "Courses" ? "open" : ""
                    } ${
                      ["/online", "/offline"].includes(currentPath)
                        ? "active"
                        : ""
                    }`}
                  >
                    <span onClick={() => toggleDropdown("Courses")}>
                      Courses
                    </span>
                    <ul>
                      <li>
                        <NavLink
                          to="/courses"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                          onClick={() => setIsMenuOpen(false)}
                        >
                          Online Course
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/offline-courses"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                          onClick={() => setIsMenuOpen(false)}
                        >
                          Offline Course
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/Books"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                          onClick={() => setIsMenuOpen(false)}
                        >
                          Correspondence Course
                        </NavLink>
                      </li>
                    </ul>
                  </li>

                  <li
                    className={`dropdown ${
                      openDropdown === "Tests" ? "open" : ""
                    } ${
                      ["/mock", "/test"].includes(currentPath) ? "active" : ""
                    }`}
                  >
                    <span onClick={() => toggleDropdown("Tests")}>Tests</span>
                    <ul>
                      <li>
                        <NavLink
                          to={user_id ? "/test-series" : "#"}
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                          onClick={(e) => {
                            if (!user_id) {
                              e.preventDefault();
                                localStorage.setItem("postLoginRedirect", "/test-series");
                              handleShow();
                            } else {
                              setIsMenuOpen(false);
                            }
                          }}
                        >
                          Live Mock Tests
                        </NavLink>
                      </li>

                      <li>
                        <NavLink
                          to={user_id ? "/off-test-Series" : "#"}
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                          onClick={(e) => {
                            if (!user_id) {
                              e.preventDefault();
                               localStorage.setItem("postLoginRedirect", "/off-test-Series");
                              handleShow();
                            } else {
                              setIsMenuOpen(false);
                            }
                          }}
                        >
                          Test Series
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          // to="/sectional-test"
                          to={user_id ? "/sectional-test" : "#"}
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                          onClick={(e) => {
                            if (!user_id) {
                              e.preventDefault();
                                  localStorage.setItem("postLoginRedirect", "/sectional-test");
                              handleShow();
                            } else {
                              setIsMenuOpen(false);
                            }
                          }}
                        >
                          Sectional test
                        </NavLink>
                      </li>
                    </ul>
                  </li>

                  {/* <li>
                    <NavLink
                      to="/About-us"
                      className={({ isActive }) => (isActive ? "active" : "")}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      About Us
                    </NavLink>
                  </li> */}

                  {/* <li>
                    <NavLink
                      to="/courses"
                      className={({ isActive }) => (isActive ? "active" : "")}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      Courses
                    </NavLink>
                  </li> */}
                  {/* <li>
                    <NavLink
                      to="/blog"
                      className={({ isActive }) => (isActive ? "active" : "")}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      Blog
                    </NavLink>
                  </li> */}
                  <li>
                    <NavLink
                      to="/scholarship"
                      className={({ isActive }) => (isActive ? "active" : "")}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      Scholarship
                    </NavLink>
                  </li>

                  {/* Dropdown menu */}
                  <li
                    className={`dropdown ${
                      openDropdown === "pages" ? "open" : ""
                    } ${
                      ["/live", "/papers"].includes(currentPath) ? "active" : ""
                    }`}
                  >
                    <span onClick={() => toggleDropdown("pages")}>Class</span>
                    <ul>
                      <li>
                        <NavLink
                          to="/Live-class"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                          onClick={() => setIsMenuOpen(false)}
                        >
                          Live Class
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/demo-class"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                          onClick={() => setIsMenuOpen(false)}
                        >
                          Free Demo Class
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to={user_id ? "/Previous-Papers" : "#"}
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                          // onClick={() => setIsMenuOpen(false)}
                          onClick={(e) => {
                            if (!user_id) {
                              e.preventDefault();
                               localStorage.setItem("postLoginRedirect", "/Previous-Papers");
                              handleShow();
                            } else {
                              setIsMenuOpen(false);
                            }
                          }}
                        >
                          Previous Papers
                        </NavLink>
                      </li>
                      {/* <li>
                        <NavLink
                          to="/Test-Series"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                          onClick={() => setIsMenuOpen(false)}
                        >
                          Test Series
                        </NavLink>
                      </li> */}
                    </ul>
                  </li>

                  <li>
                    <NavLink
                      to="/Books"
                      className={({ isActive }) => (isActive ? "active" : "")}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      Books
                    </NavLink>
                  </li>

                  <li className="only_mobile">
                    {token ? (
                      <NavLink to="/dashboard"
                        className={({ isActive }) => (isActive ? "active" : "")}
                        // onClick={() => navigate("/dashboard")}
                        onClick={() => setIsMenuOpen(false)}
                      >
                        My Account
                      </NavLink>
                    ) : (
                      <NavLink
                        className={({ isActive }) => (isActive ? "" : "")}
                        onClick={handleShow}
                      >
                        Login
                      </NavLink>
                    )}
                  </li>

                  <li className="only_mobile">
                    <NavLink
                      to="/refer"
                      className={({ isActive }) => (isActive ? "active" : "")}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      Refer & Earn
                    </NavLink>
                  </li>

                  {/* <li>
                    <NavLink
                      to="/contact-us"
                      className={({ isActive }) => (isActive ? "active" : "")}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      Contact
                    </NavLink>
                  </li> */}
                  <button
                    className="main-menu__close d-lg-none"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    <FaTimes />
                  </button>
                </ul>

                {/* Only show in mobile view */}
                <div className="header_icons mt-5">
                  <ul className="unstyled social_icons_list">
                    <li>
                      <a
                        href={fooder.insta_link}
                        target="_blank"
                        rel="noopener noreferrer"
                          aria-label="Exceller Instagram"
                      >
                        <FaInstagram />
                      </a>
                    </li>
                    <li>
                      <a
                        href={fooder.facebook_link}
                        target="_blank"
                        rel="noopener noreferrer"
                          aria-label="Exceller Facebook"
                      >
                        <FaFacebookF />
                      </a>
                    </li>
                    <li>
                      <a
                        href={fooder.youtube_link}
                        target="_blank"
                        rel="noopener noreferrer"
                          aria-label="Exceller Youtube"
                      >
                        <FaYoutube />
                      </a>
                    </li>
                    <li>
                      <a
                        href={fooder.whatsApp_link}
                        target="_blank"
                        rel="noopener noreferrer"
                          aria-label="Whatsapp"
                      >
                        <FaWhatsapp />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="main-menu__right">
                <div
                  className="main-menu__login gap-2"
                  onClick={() => navigate("/BookCart")}
                >
                  <div className="cart" title="Cart">
                    <FaCartShopping />
                    <span className="count">
                      {cartCount > 0 ? cartCount : ""}
                    </span>
                  </div>
                  {/* <p className="text-light">Cart</p> */}
                </div>

                {token ? (
                  <span
                    className="educate-btn sm d-md-flex d-none"
                    onClick={() => navigate("/dashboard")}
                  >
                    <span className="educate-btn__curve" />
                    My Account
                  </span>
                ) : (
                  <NavLink
                    // to="/login"
                    title="Login"
                    className="d-md-flex d-none main-menu__login"
                    onClick={handleShow}
                  >
                    <FaRegUser />
                  </NavLink>
                )}

                {/* <Link
                  to="/contact-us"
                  className="educate-btn sm d-md-flex d-none"
                >
                  <span className="educate-btn__curve" />
                  Enroll Now
                </Link> */}

                <NavLink
                  to="/refer"
                  title="Refer & Earn"
                  className="refer_btn  d-md-flex d-none"
                >
                  <BsFillGiftFill />
                  {/* <img src={refer} alt="refer" title="Refer & Earn"/> */}
                </NavLink>

                <span
                  className="main-menu__toggler mobile-nav__toggler"
                  onClick={toggleMenu}
                >
                  <FaBars />
                </span>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        className="loginSideBar"
        backdrop="static"
      >
        <Offcanvas.Header closeButton>
          <h4>Login</h4>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <SigninLeft handleClose={handleClose} />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default Header;
